module.exports = __webpack_public_path__ + "static/media/S3N7-6.ccfec543.svg";